<template>

  <div class="grid-container">

    <div class="grid-x">

      <div class="cell small-12 medium-4 medium-offset-2 promise-10">
        <h6>{{valuePromiseContent.title}}</h6>
        <p>{{valuePromiseContent.subtitle}}</p>
      </div>

      <div class="cell small-12 medium-5 medium-offset-.5 promise-10">
        <ul class="promiseList">
          <li class="promiseItems" v-for="service in valuePromiseContent.includedServices" :key="service">
            <img height="20" width="20" :src="valuePromiseContent.checkmark" alt="green checkmark">
            <p>{{service}}</p>
          </li>
        </ul>
      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: 'ComponentPromise',
  props: ['valuePromiseContent']
}
</script>

<style lang="scss">

.promise-10 {
  padding: 10px;
}

.promiseItems {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  p {margin-bottom: 0; padding-bottom: 0;}
}
</style>
